export default __webpack_public_path__ + "static/media/basicCircle.de4cd6f3.svg";